export const LEX_LOGIN_DSP = 'LEX_LOGIN_DSP';
export const LEX_LOGINDSP_SUCCESS = 'LEX_LOGINDSP_SUCCESS';
export const LEX_LOGINDSP_ERROR = 'LEX_LOGINDSP_ERROR';
